export default __webpack_public_path__ + "static/media/gm-power-transfer.a80bc43b.svg";